import React from 'react';
import ContentRouteForward from '../ContentRouteForward';

export default [
  <ContentRouteForward
    key="/business/showcase/content/:pageKey"
    path="/business/showcase/content/"
  />,
];
